import keyMirror from "@kopapro-redux/utils/key-mirror";

export default keyMirror({
  GET_PAYMENTMETHODS_REQUEST: null,
  RECEIVED_PAYMENTMETHODS: null,
});
